/**
 * @class CrossSellCard
 * @classdesc The class for a product cross sell card.
 *
 * @extends Core.Component
 */
export default class CrossSellCard extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.state = {
      product: this.data.product,
      selectedVariant: this.data.selectedVariant,
    };

    this._imgChangeFn = this._updateSelectedImage.bind(this);
  }

  onMount() {
    this.productImage = this.el.querySelector('[data-product-image]');
    this.productVariantColorLabel = this.el.querySelectorAll('[data-variant-color-label]');
    this.swatches = this.query('product-card-swatches');
    this.selectOptionsLink = this.el.querySelector('[data-cross-sell-card-atc]');
    this.backLink = this.el.querySelector('[data-cross-sell-card-back]');
    this.productDetails = this.el.querySelector('[data-cross-sell-card-details]');
    this.productForm = this.el.querySelector('[data-cross-sell-card-form]');
    this.optionsSelector = this.query('options-selector');

    this._bindEvents();
  }

  onDismount() {
    this.events.unregisterAll();
  }

  /**
   * Binds card events (click event to toggle form etc.)
   */
  _bindEvents() {
    if (this.swatches) {
      this.events.register(this.swatches.el, 'swatch:update', e => {
        this._imgChangeFn(e.detail);
      });

      this.events.register(this.el, 'cross-sell:selected', event => {
        // In the case where the cards are animating from display: none (ie. the 
        // cart drawer), the 'overflowing' swatches won't register on load as hidden
        // because the height of the element is 0.
        // We handle this by emitting an event on the card in the parent element which
        // triggers an extra check for hidden swatches
        setTimeout(() => { this.swatches.hiddenButtonsCheck(); }, 50);
      });
    }

    this.events.register(this.selectOptionsLink, 'click', e => {
      e.preventDefault();
      this._toggleProductForm();
    });

    this.events.register(this.backLink, 'click', e => {
      e.preventDefault();
      this._toggleProductForm();
    });

    this.events.register(this.el, 'product:variant-change', event => this._onVariantChange(event));
  }

  _onVariantChange(event) {
    const { product, variant } = event.detail;
    this.setState({ selectedVariant: variant });

    const buyButtons = this.query('buy-buttons');

    if (variant) {
      if (variant.available) {
        buyButtons.setButtonState('available');
      } else {
        buyButtons.setButtonState('sold out');
      }
    } else {
      buyButtons.setButtonState('unavailable');
    }
  }

  /**
   * Toggle the product form or product details into view
   */
  _toggleProductForm() {
    this.productDetails.classList.toggle('hidden');
    this.productForm.classList.toggle('hidden');

    if (this.optionsSelector) {
      this.optionsSelector.setSelectedOptions(this.state.selectedVariant.options);
    }
  }

  /**
   * When a swatch is selected, change the backround image to that variant image
   * @param color {string} - the name of the variant color to identify the image
   */
  _updateSelectedImage({ color, variantIndex }) {
    const currentImage = this.el.querySelector(`[data-variant-image="${color}"]`);
    const variantImagesContainer = this.el.querySelector('[data-variant-images]');
    const variantImages = variantImagesContainer.querySelectorAll('[data-variant-image]');
    const initialImage = this.el.querySelector('[data-cross-sell-card-img]');

    const variant = this.state.product.variants[variantIndex];

    if (variant && variant.available) {
      this.setState({ selectedVariant: variant });

      this.productVariantColorLabel.forEach(el => {
        const colorString = color.charAt(0).toUpperCase() + color.slice(1);
        el.innerHTML = colorString;
      });

      if (currentImage) {
        variantImagesContainer.classList.add('hidden');

        variantImages.forEach(image => {
          image.classList.add('hidden');
        });

        variantImagesContainer.classList.remove('hidden');
        currentImage.classList.remove('hidden');
        initialImage.classList.add('hidden');
      }
    }
  }
}
